import axios from 'axios';
import authHeader from '/src/services/auth-header';

// VUE_APP_BASE_URL=http://127.0.0.1:8080/api
//const API_URL = 'http://192.168.100.176:8080/api/auth/';
//const API_URL = 'http://localHost:8080/api/auth/';
const API_URL = process.env.VUE_APP_BASE_URL_API + '/auth/';
//const API_URL = 'http://192.168.100.242:8080/api/auth/';

class AuthService {
   login(user) {
      return axios
         .post(API_URL + 'signin', {
            username: user.username,
            password: user.password
         })
         .then(response => {
            if (response.data.accessToken) {
               localStorage.setItem('user', JSON.stringify(response.data));
            }
            return response.data;
         });
   }

   logout() {
      localStorage.removeItem('user');
   }

   register(user) {
      return axios.post(API_URL + 'signup', {
         lastname: user.lastname,
         names: user.names,
         username: user.username,
         email: user.email,
         password: user.password,
         confirmok: user.confirmok
      });
   }
   
   changePass(user) {
      return axios.post(API_URL + 'changepass', {
         username: user.username,
         password: user.password
      });
   }

   forgotPass(user) {
      return axios.post(API_URL + 'forgotpass', {
         username: user.username,
         password: user.password    // use passwork as email in backend
      });
   }
   
   kaUser(userId) {
      return axios.get(API_URL + `kauser/${userId}`,  { headers: authHeader() });
   }
}

export default new AuthService();
